const IconExpand = () => {
  return (
    <svg viewBox="0 0 144 144" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
      <path
        className="st0"
        d="M129.8,128.3l-3.9-31.1c-.1-1.1-1.4-1.5-2.2-.8l-9,9-25.2-25.2c-.5-.5-1.3-.5-1.9,0l-7.4,7.4c-.5.5-.5,1.3,0,1.9l25.2,25.2-9,9c-.5.5-.5,1.3,0,1.8.2.2.5.3.8.4l31,3.8c.7,0,1.4-.4,1.5-1.1,0-.1,0-.2,0-.4Z"
      />
      <path
        className="st0"
        d="M63.7,56.3c.5-.5.5-1.3,0-1.9l-25.2-25.2,9-9c.5-.5.5-1.3,0-1.8-.2-.2-.5-.3-.8-.4l-31-3.9c-.9,0-1.6.6-1.5,1.5l3.9,31.1c.1,1.1,1.4,1.5,2.2.8l9-9,25.2,25.2c.5.5,1.3.5,1.9,0l7.4-7.4Z"
      />
      <path
        className="st0"
        d="M128.3,14.2l-31.1,3.9c-1.1.1-1.5,1.4-.8,2.2l9,9-25.2,25.2c-.5.5-.5,1.3,0,1.9l7.4,7.4c.5.5,1.3.5,1.9,0l25.2-25.2,9,9c.5.5,1.3.5,1.8,0,.2-.2.3-.5.4-.8l3.8-31c0-.7-.4-1.4-1.1-1.5-.1,0-.2,0-.4,0Z"
      />
      <path
        className="st0"
        d="M56.3,80.3c-.5-.5-1.3-.5-1.9,0l-25.2,25.2-9-9c-.5-.5-1.3-.5-1.8,0-.2.2-.3.5-.4.8l-3.9,31c0,.9.6,1.6,1.5,1.5l31.1-3.9c1.1-.1,1.5-1.4.8-2.2l-9-9,25.2-25.2c.5-.5.5-1.3,0-1.9l-7.4-7.4Z"
      />
    </svg>
  );
};

export default IconExpand;
